import React from 'react';
import PropTypes from 'prop-types';
import { Box, BoundedContent, H2, Typography } from '@vp/swan';
import { ReplaceTokens, useTranslations } from '@vp/om-translations';
import errorImage from '../../shared/icons/errorImage.svg';
import { EmbeddableLinkCreator } from '../../shared/EmbeddableLinkCreator';

const DesignFeedbackErrorPage = ({ error = {} }) => {
  const [errorMessages, customerCancelMessages] = useTranslations([
    'errorMessages',
    'customerCancelMessages',
  ]);

  const ContactCareLink = EmbeddableLinkCreator({
    href: 'google.com',
    tabIndex: 0,
  });

  // A map of error status to i18n errorMessages Translation Group keys.
  const errorMap = {
    default: {
      errorTitle: errorMessages.oopsSomethingWentWrong,
      errorMessage: (
        <ReplaceTokens
          tokenizedString={
            customerCancelMessages.cancellationRequestFailedContentRetryable
          }
          substitutions={{
            ContactCareLink,
          }}
        />
      ),
    },
  };

  const errorStatus = error?.response?.status;
  const errorMessagesForStatus = errorMap[errorStatus] || errorMap.default;
  const { errorTitle, errorMessage } = errorMessagesForStatus;

  return (
    <BoundedContent>
      <Box my={9}>
        <img src={errorImage} alt="" />
        <H2 mt={7} fontSize="x2large">
          {errorTitle}
        </H2>
        <Typography mt={5}>{errorMessage}</Typography>
      </Box>
    </BoundedContent>
  );
};

export default DesignFeedbackErrorPage;

DesignFeedbackErrorPage.propTypes = {
  error: PropTypes.object,
};
